function initialiseCapptureFilms(root = document) {
  root.querySelectorAll('[data-cappture-film]').forEach((video) => {
    if (video.dataset.captionsReady) return;
    video.dataset.captionsReady = 'true';
    const syncCaptions = () => {
      for (const track of video.textTracks) {
        if (track.kind === 'captions') track.mode = video.muted || video.volume === 0 ? 'showing' : 'disabled';
      }
    };
    video.addEventListener('volumechange', syncCaptions);
    video.addEventListener('loadedmetadata', syncCaptions);
    syncCaptions();
    const player = video.closest('[data-cappture-player]');
    const playButton = player?.querySelector('[data-cappture-play]');
    const endCard = player?.querySelector('[data-cappture-end-card]');
    const replayButton = video.closest('.daylight__video')?.querySelector('[data-cappture-replay]');
    const ctaStart = Number(player?.dataset.capptureCtaStart);
    const hideControl = (control) => {
      if (!control) return;
      if (control.contains(document.activeElement)) video.focus({ preventScroll: true });
      control.hidden = true;
    };
    const syncPlayer = () => {
      const atClosing = video.ended || (Number.isFinite(ctaStart) && video.currentTime >= ctaStart);
      if (endCard && atClosing) endCard.hidden = false;
      else hideControl(endCard);
      if (replayButton && video.ended) replayButton.hidden = false;
      else hideControl(replayButton);
      if (playButton) {
        if (atClosing || !video.paused || video.currentTime > 0) hideControl(playButton);
        else playButton.hidden = false;
      }
    };
    const requestPlayback = (restart = false) => {
      if (restart) video.currentTime = 0;
      video.play().catch(() => {
        syncPlayer();
        if (playButton && !video.ended && (!Number.isFinite(ctaStart) || video.currentTime < ctaStart)) playButton.hidden = false;
      });
    };
    playButton?.addEventListener('click', () => requestPlayback());
    replayButton?.addEventListener('click', () => requestPlayback(true));
    video.addEventListener('play', syncPlayer);
    video.addEventListener('playing', syncPlayer);
    video.addEventListener('seeking', syncPlayer);
    video.addEventListener('timeupdate', syncPlayer);
    video.addEventListener('webkitendfullscreen', syncPlayer);
    video.addEventListener('ended', () => {
      syncPlayer();
      if (video.webkitDisplayingFullscreen && typeof video.webkitExitFullscreen === 'function') {
        try { video.webkitExitFullscreen(); } catch {}
      }
      if (document.fullscreenElement === video && typeof document.exitFullscreen === 'function') {
        document.exitFullscreen().catch(() => {});
      }
    });
    syncPlayer();
    const section = video.closest('.daylight');
    const filmLink = section?.querySelector('.daylight__film-link');
    filmLink?.addEventListener('click', () => {
      if (video.paused) requestPlayback(video.ended);
    });
  });
}
initialiseCapptureFilms();
document.addEventListener('shopify:section:load', (event) => initialiseCapptureFilms(event.target));
